import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import URIs from "../utils/uri";

const RequireAuth = ({ allowedRoles = [] }) => {
    const { auth } = useAuth();
    const location = useLocation();

    if (!auth?.accessToken) {
        // Redirect to login if not authenticated
        return <Navigate to={URIs.LOGIN} state={{ from: location }} replace />;
    }
    if (allowedRoles.length && !allowedRoles.some(role => auth?.roles?.includes(role))) {
        // Redirect to unauthorized if user lacks proper roles
        return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }

    // Allow access if authenticated and authorized
    return <Outlet />;
};

export default RequireAuth;
